import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { restServices } from 'src/app/rest.service';
import { UserLdapDto } from '../../models/entities/user-ldap-dto';
import { Observable } from 'rxjs';
import { UserLdap } from '../../models/entities/user-ldap';
import { Utente } from '../../models/general/utente';
import { StorageService } from '../general-utils';
import { USER_DATA_KEY } from 'src/app/shared/constants/app.constants';
import { DisableUserLdapDTO } from '../../models/entities/disable-user-ldap-dto';
import { CambioPasswordDTO } from '../../models/entities/cambio-password-dto';

type EntityResponseTypeUtenteLdap = HttpResponse<UserLdapDto>;
type EntityArrayResponseTypeUtentiLdap = HttpResponse<UserLdapDto[]>;

@Injectable()
export class UserService {

  resourceUsers = environment.api_url + restServices.users;
  resourceUtentiLdap = environment.api_url + restServices.utentiLdap;
  resourceTenant = environment.api_url + restServices.tenant;

  private currentUser: Utente;

  constructor(
    private http: HttpClient,
    private storageService: StorageService) {
    // se faccio un reload perdo l'utente del servizio che è popolato al login; lo rigenero
    this.updateUser();
  }

  /**
   * Dopo il login, popola dati utente
   */
  updateUser() {
    const user = JSON.parse(this.storageService.getItem(USER_DATA_KEY)).user;
    // se sono loggato mi metto via l'utente
    if (user) {
      this.currentUser = user;
    }
  }

  getOrganizationUnits() {
    let orgUnits = [];
    JSON.parse(this.storageService.getItem(USER_DATA_KEY)).user.organizationUnits.forEach((ou: string) => {
      orgUnits.push(ou);
    });
    if (orgUnits.length > 1) {
      orgUnits.push('Generica');
    }
    return orgUnits;
  }

  getCurrentUser(): Utente {
    return this.currentUser;
  }

  findCurrentUser() {
    return this.http.get<UserLdap>(environment.api_url + 'find-current-user', { observe: 'response' });
  }

  changePassword(cambioPasswordDTO: CambioPasswordDTO) {
    return this.http.post(environment.api_url + 'change-password', cambioPasswordDTO);
  }

  updateUserLdap(userLdap: UserLdap) {
    return this.http.post(environment.api_url + 'update-user', userLdap, { observe: 'response' });
  }

  findApplicationIds(userId: String) {
    return this.http.post(environment.api_url + 'find-application-ids', userId);
  }

  findTenant() {
    return this.http.get(`${this.resourceUsers}/tenant`);
  }

  findAziende() {
    return this.http.get(`${this.resourceUsers}/ou`);
  }

  getAllUtenti(): Observable<EntityArrayResponseTypeUtentiLdap> {
    return this.http.get<UserLdapDto[]>(this.resourceUtentiLdap, { observe: 'response' });
  }

  insertUtenteLdap(utenteLdap: UserLdapDto): Observable<EntityResponseTypeUtenteLdap> {
    return this.http.post<UserLdapDto>(`${this.resourceUtentiLdap}`, utenteLdap, { observe: 'response' });
  }

  updateUtenteLdap(utenteLdap: UserLdapDto): Observable<EntityResponseTypeUtenteLdap> {
    return this.http.put<UserLdapDto>(`${this.resourceUtentiLdap}`, utenteLdap, { observe: 'response' });
  }

  getUtenteByUid(uid: string): Observable<EntityResponseTypeUtenteLdap> {
    return this.http.get<UserLdapDto>(`${this.resourceUtentiLdap}/${uid}/`, { observe: 'response' });
  }

  getAllTenant(): Observable<HttpResponse<string[]>> {
    return this.http.get<string[]>(this.resourceTenant, { observe: 'response' });
  }

  disableUtenteLdap(input: DisableUserLdapDTO): Observable<HttpResponse<DisableUserLdapDTO>> {
    return this.http.put<DisableUserLdapDTO>(`${this.resourceUtentiLdap}/${restServices.disable}`, input, { observe: 'response' });
  }

  enableUtenteLdap(input: DisableUserLdapDTO): Observable<HttpResponse<DisableUserLdapDTO>> {
    return this.http.put<DisableUserLdapDTO>(`${this.resourceUtentiLdap}/${restServices.enable}`, input, { observe: 'response' });
  }

  /** Eliminazione definitiva (non ripristinabile) dell'utente */
  deleteUtenteLdap(uid: string): Observable<HttpResponse<void>> {
    return this.http.delete<void>(`${this.resourceUtentiLdap}/${uid}/`, { observe: 'response' });
  }

}
